import _ from "lodash";

export const debounceCategoryList = _.debounce(async (apiFunction, setData) => {
  try {
    const response = await apiFunction();

    if (response.status === "success") {
      // Map patientCategoryName to name for backward compatibility with component
      const mappedRows = response.result.rows?.map((category) => ({
        ...category,
        name: category.patientCategoryName,
      }));
      setData(mappedRows);
    }
  } catch (error) {
    console.log(error);
  }
}, 300);
